import { render, staticRenderFns } from "./smartLight.vue?vue&type=template&id=4b78d0a4"
import script from "./smartLight.vue?vue&type=script&lang=js"
export * from "./smartLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports